/**
 * Date-extensions locale Macedonian [mk]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('mk', {
    monthNames: ['јануари','февруари','март','април','мај','јуни','јули','август','септември','октомври','ноември','декември'],
    monthShortNames: ['јан','фев','мар','апр','мај','јун','јул','авг','сеп','окт','ное','дек'],
    dayNames: ['недела','понеделник','вторник','среда','четврток','петок','сабота'],
    dayShortNames: ['нед','пон','вто','сре','чет','пет','саб']
});
